export const phoneNumberMeta: Record<string, Record<string, any>> = {
  AR: {
    phoneCountry: '+549',
    selectLabel: 'Argentina (+549)',
    regexValidation: /^(?:11\d{8}|[2368]\d{2}\d{7})$/,
    helpText: 'Ingrese el número sin el 0 y sin el 15',
  },
  BR: {
    phoneCountry: '+55',
    selectLabel: 'Brasil (+55)',
    regexValidation: /^(\d{2}9\d{8})$/,
    helpText: 'Ingrese el número con el formato AA 9 NNNN NNNN',
  },
  DE: {
    phoneCountry: '+49',
    selectLabel: 'Alemania (+49)',
    // Móviles alemanes suelen comenzar con 15/16/17 y tener 10-11 dígitos sin el 0 inicial
    regexValidation: /^1[5-7]\d{8,9}$/,
    helpText: 'Ingrese el número sin el 0 inicial',
  },
  ES: {
    phoneCountry: '+34',
    selectLabel: 'España (+34)',
    // Móviles en España empiezan con 6 o 7 y tienen 9 dígitos
    regexValidation: /^[67]\d{8}$/,
    helpText: 'Ingrese el número con el formato 6/7 NNN NNN NNN',
  },
  PY: {
    phoneCountry: '+595',
    selectLabel: 'Paraguay (+595)',
    regexValidation: /^(9\d{8})$/,
    helpText: 'Ingrese el número con el formato 9 NN NNNNNN',
  },
  UR: {
    phoneCountry: '+598',
    selectLabel: 'Uruguay (+598)',
    regexValidation: /^(9\d{8})$/,
    helpText: 'Ingrese el número con el formato NN NNN NNN',
  },
  CH: {
    phoneCountry: '+569',
    selectLabel: 'Chile (+569)',
    regexValidation: /^[98765432]\d{7}$/,
    helpText: 'Ingrese el número con el formato NN NNN NNN',
  },
  BO: {
    phoneCountry: '+591',
    selectLabel: 'Bolivia (+591)',
    regexValidation: /^[67]\d{7}$/,
    helpText: 'Ingrese el número con el formato [6|7] NN NNNNN',
  },
  US: {
    phoneCountry: '+1',
    selectLabel: 'Estados Unidos (+1)',
    // Números de 10 dígitos (AAA) BBB CCCC
    regexValidation: /^\d{10}$/,
    helpText: 'Ingrese el número con el formato NNN NNN NNNN',
  },
};

export const countryByCode: Record<string, string> = {
  '+549': 'AR',
  '+55': 'BR',
  '+49': 'DE',
  '+34': 'ES',
  '+595': 'PY',
  '+598': 'UR',
  '+569': 'CH',
  '+591': 'BO',
  '+1': 'US',
};

// Enum por IDs de país (según listado provisto)
// Claves = códigos internos usados en phoneNumberMeta
export enum Country {
  AR = 1, // Argentina
  BR = 3, // Brasil
  DE = 9, // Alemania
  ES = 7, // España
  PY = 4, // Paraguay
  UR = 2, // Uruguay
  CH = 5, // Chile
  US = 6, // Estados Unidos
  // BO // Bolivia: no incluida en el listado provisto
}
